<nb-card class="dialog">
  <nb-card-header>Untermieter zuweisen</nb-card-header>
  <nb-card-body class="form">
    <div class="field">
      <label class="label" for="sectionSelect">Gebäudeteil</label>
      <nb-select
        id="sectionSelect"
        placeholder="Gebäudeteil auswählen"
        [formControl]="sectionId"
        fullWidth>
        @for (section of sections; track section.id) {
          <nb-option [value]="section.id">{{ sectionLabel(section) }}</nb-option>
        }
      </nb-select>
    </div>

    <div class="field">
      <label class="label" for="tenantSelect">Untermieter</label>
      <wr-tenant-select
        id="tenantSelect"
        [formControl]="tenantId"
        [tenantType]="TenantType.External">
      </wr-tenant-select>
    </div>

    @if (duplicate()) {
      <p class="error">Diese Zuweisung besteht bereits.</p>
    }
  </nb-card-body>
  <nb-card-footer class="actions">
    <button nbButton ghost (click)="cancel()">Abbrechen</button>
    <button
      nbButton
      status="primary"
      [disabled]="!canSubmit()"
      (click)="submit()">
      Zuweisen
    </button>
  </nb-card-footer>
</nb-card>
